import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet } from '@neptune/cx/utils';
import {forEach} from "lodash";

const gc = new DisposalSet();

registerFragment('chroa-faq-wrap', (fragmentElement, config, meta) => {
    const faqContainers = document.querySelectorAll('.faq-accordion-container');
    faqContainers.forEach(cont => {
        const expandAllBtn = cont?.querySelector('.expand-all-t');
        const closeAllBtn = cont?.querySelector('.close-all-t');
        const faqSelectors = cont?.querySelectorAll('.faq-selector');

        expandAllBtn?.addEventListener('click', (e:Event)=>{
            e.preventDefault();
            faqSelectors.forEach(selector => {
                (selector as HTMLInputElement).checked = true;
            });
            (expandAllBtn as HTMLElement).style.display = 'none';
            (closeAllBtn as HTMLElement).style.display = 'block';
        })
        closeAllBtn?.addEventListener('click', (e:Event)=>{
            e.preventDefault();
            faqSelectors.forEach(selector => {
                (selector as HTMLInputElement).checked = false;
            });
            (closeAllBtn as HTMLElement).style.display = 'none';
            (expandAllBtn as HTMLElement).style.display = 'block';
        })
    })
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
